/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{glsl as i}from"../shaderModules/glsl.js";function o(o,t=!0){o.attributes.add("position","vec2"),t&&o.varyings.add("uv","vec2"),o.vertex.main.add(i`
      gl_Position = vec4(position, 0.0, 1.0);
      ${t?i`uv = position * 0.5 + vec2(0.5);`:""}
  `)}export{o as ScreenSpacePass};
